import React, { useEffect, useState } from 'react';
import ToolBar from '../../../components/ToolBar';
// import ListTable from '../Monitor/components/ListTable';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import SubmitForm from '../Manual/components/SubmitForm';
import NumberForm from './components/NumberForm';
import SearchForm from './components/SearchForm';
import ListTable from './components/ListTable';
import { Tabs } from 'antd';
import { fetchNumberManagementList } from '../../../store/NumberManagementSlice';
import { CONSTANT } from '../../../config/Constant';

const NumberManagement: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [isPagination, setIsPagination] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  // const [dataViewDrawer, setDataViewDrawer] = useState<any>();
  // const [apiResponse, setApiResponse] = useState<any>();

  const getList = (data?: any) => {
    setTableLoading(true);
    const payload = {
      ...data,
      number: data?.number ? data?.number : '',
      to_number: data?.to_number ? data?.to_number : '',
      current: data?.current ?? 1,
      page_size: data?.page_size ?? 10,
    };
    dispatch(fetchNumberManagementList(payload))
      .then((res: any) => {
        setListData(res?.data?.mapResponse);
        setTotalData(res?.data?.totalData);
        setIsPagination(res?.data?.isPagination);
        setTableLoading(false);
      })
      .catch(() => {
        setListData([]);
        setTotalData(0);
        setTableLoading(false);
      });
  };

  const token = localStorage.getItem('token');
  useEffect(() => {
    if (token && token !== 'undefined') {
      getList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      //console.log('WebSocket connection established');
    };

    ws.onclose = function () {
      //console.log('WebSocket connection closed');
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);
      // const eventData = event.data;
      // //console.log('eventData', eventData);
      // //console.log('eventData', eventData);
      const token = localStorage.getItem('token');
      if (token === null) {
        navigate('/login');
      }

      const getNumber = eventData?.user_id;
      // setDataViewDrawer({ number: getNumber });

      if (getNumber) {
        // setApiResponse(getNumber);
        getList();
      } else {
        ws.close();
      }
    };
  };
  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ToolBar title={'Number Management'} />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        onChange={() => {
          getList();
        }}
        items={[
          {
            key: '1',
            label: 'Add New Number',
            children: <NumberForm getList={getList} />,
          },
          {
            key: '2',
            label: 'Search in List',
            children: (
              <SearchForm
                paginationData={paginationData}
                getList={getList}
                setSavePayload={setSavePayload}
              />
            ),
          },
        ]}
      />

      <ListTable
        listData={listData}
        setListData={setListData}
        totalData={totalData}
        tableloading={tableloading}
        setTableLoading={setTableLoading}
        paginationData={paginationData}
        setPaginationData={setPaginationData}
        getList={getList}
        savePayload={savePayload}
        isPagination={isPagination}
      />
    </>
  );
};

export default NumberManagement;
